import {
	getErrorReport,
	postErrorResolve,
} from '../../services/api/error.api';
import {
	GET_ERROR_REQUEST,
	GET_ERROR_SUCCESS,
	GET_ERROR_FAILURE,
	POST_RESOLVE_ERROR_REQUEST,
	POST_RESOLVE_ERROR_SUCCESS,
	POST_RESOLVE_ERROR_FAILURE,
} from '../types';
import {
	transformErrorList,
	transformError,
} from '../../transforms/error';
import { transformPagination } from '../../transforms/pagination';

export default {
	namespaced: true,

	state: {
		isLoading: false,
		error: null,
		data: [],
		pagination: transformPagination({}),
	},

	mutations: {
		[GET_ERROR_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
			state.data = [];
		},
		[GET_ERROR_SUCCESS](state, { data, meta }) {
			state.isLoading = false;
			state.data = transformErrorList(data);
			state.pagination = transformPagination(meta);
		},
		[GET_ERROR_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
		[POST_RESOLVE_ERROR_REQUEST](state) {
			state.isLoading = true;
			state.error = null;
		},
		[POST_RESOLVE_ERROR_SUCCESS](state) {
			state.isLoading = false;
		},
		[POST_RESOLVE_ERROR_FAILURE](state, error) {
			state.isLoading = false;
			state.error = transformError(error);
		},
	},

	actions: {
		async getErrorData({ commit }, _params = {}) {
			const params = {
				'filters[type]': _params.type,
				'filters[channel_id]': _params.channels,
				'filters[status]': _params.status,
				sort_by: _params.sort_by,
				sort_direction: _params.sort_direction,
				page: _params.page,
				per_page: 30,
			};
			try {
				commit(GET_ERROR_REQUEST);
				const { data } = await getErrorReport(params);
				commit(GET_ERROR_SUCCESS, data);
			} catch (error) {
				commit(GET_ERROR_FAILURE, error);
			}
		},
		async updateErrorResolve({ commit }, { id, params }) {
			try {
				commit(POST_RESOLVE_ERROR_REQUEST);
				await postErrorResolve(id, params);
				commit(POST_RESOLVE_ERROR_SUCCESS);
			} catch (error) {
				commit(POST_RESOLVE_ERROR_FAILURE, error);
			}
		},
	},
};
